import { createColumn, ColumnWidth } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import ColumnStrings from '../columns.resx';
import { Facet } from '../../../models/Facet';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { DateRenderer } from '../../fields/date/DateRenderer';
import { ISpecifiedItemProps } from '../../decorators/selectors';

export const dateModifiedColumn: IColumn = createColumn({
  key: new Facet('dateModifiedColumn').id,
  name: ColumnStrings.ModifiedDate,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax,
  isCollapsable: true
}, DateRenderer)((itemCache: IItemCache, itemKey: string) => {
  return (): ISpecifiedItemProps => {
    return {
      itemKey
    };
  };
});
